import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const nom035 = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;
    const getHeaders = () => withAuth ? Authorization() : {};
    return {
        getQuestionnaire: (params) => executeCall(() =>
            Axios.get(`${url}/questionnaire`, { params, headers: getHeaders() })
        ),
        submitAssessment: (data) => executeCall(() =>
            Axios.post(`${url}/assessment`, data, { headers: getHeaders() })
        ),
        getMyAssessments: () => executeCall(() =>
            Axios.get(`${url}/my-assessments`, { headers: getHeaders() })
        ),
        getPatientsAssessments: () => executeCall(() =>
            Axios.get(`${url}/patients`, { headers: getHeaders() })
        ),
    };
};

// Para rutas /business/nom035/*
const businessNom035 = (domain, _resource, withAuth = true) => {
    const url = `${domain}/business/nom035`;
    const getHeaders = () => withAuth ? Authorization() : {};
    return {
        getReport: () => executeCall(() =>
            Axios.get(`${url}/report`, { headers: getHeaders() })
        ),
        getEmployeesStatus: () => executeCall(() =>
            Axios.get(`${url}/employees`, { headers: getHeaders() })
        ),
        exportExcel: (params) => executeCall(() =>
            Axios.get(`${url}/report/excel`, {
                params,
                headers: getHeaders(),
                responseType: 'blob',
            })
        ),
        downloadPdf: () =>
            Axios.get(`${url}/report/pdf`, { headers: getHeaders(), responseType: 'blob' }),
    };
};

export { businessNom035 };
export default nom035;
